import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import ImageCropper from "../ImageCropper";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";

import CropProfileImage from "./ImageCrop/CropProfileImage";
import LocationAutocomplete from "../LocationAutocomplete/LocationAutocomplete";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const ProfileEditView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [nativeLocation, setNativeLocation] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [qualification, setQualification] = useState("10th or Below 10th");
  const [about, setAbout] = useState("");
  const [addSkillstate, setAddSkillstate] = useState("");
  const [skills, setSkills] = useState([]);
  const [addTSkillstate, setAddTSkillstate] = useState("");
  const [tskills, setTSkills] = useState([]);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [gender, setGender] = useState("Male");
  const [webLink, setWebLink] = useState("");
  const [isProfilePicModelOpen, setIsProfilePicModelOpen] = useState(false);
  const [isCropProfilePicModelOpen, setIsCropProfilePicModelOpen] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(undefined);
  const [profileImage, setProfileImage] = useState(undefined);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    setName(user.first_name + " " + user.last_name);
    setFirstname(user.first_name || "");
    setLastname(user.last_name || "");
    setProfileImage(
      user.profile_image == ""
        ? "assets/images/profile-upload.png"
        : (user.profile_image.includes("https://") ? user.profile_image : `${process.env.REACT_APP_BACKEND_BASE_URL}/` + user.profile_image)
    );
    if(user.age!= "null"){
      setAge(user.age);
    }
    
    setGender(user.gender);
    setNativeLocation(user.native_location);
    setCurrentLocation(user.location);
    setQualification(user.qualification);
    setAbout(user.about_description);
    let tempskills = user.skills;

    setTags(tempskills.split(","));
    if(user.web_link!="null"){
      setWebLink(user.web_link);
    }
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const preventNumeric = (e) => {
    const char = e.key;
    if (/[0-9]/.test(char)) {
      e.preventDefault();
    }
  };

  const filterNumeric = (value, setter) => {
    const filteredValue = value.replace(/[0-9]/g, '');
    setter(filteredValue);
  };

  const handletagChange = (tags) => {
    const filteredTags = tags
      .map(tag => tag.trim()) 
      .filter(tag => tag.length > 0); 
    if (tags.length > 10) {
      toast.error("Maximum 10 skills allowed!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return; 
    }
    setTags(filteredTags);
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
   

      setImageToCrop(event.target.files[0]);
      setProfileImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      background: "transparent",
    },
    overlay: { zIndex: 1000 },
  };
  let openProfilePicmodel = () => {
    setIsProfilePicModelOpen(true);
  };
  let closeProfilePicModel = () => {
    setIsProfilePicModelOpen(false);
  };


  let openCropProfilePicmodel = (e) => {
    e.preventDefault();
    setIsCropProfilePicModelOpen(true);
  };
  let closeCropProfilePicModel = () => {
    setIsCropProfilePicModelOpen(false);
  };

  let selectedPic = () => {
    setIsProfilePicModelOpen(false);
    var urlCreator = window.URL || window.webkitURL;
    var file = new File([croppedImage], "profile_picture.jpg", {
      type: "image/jpeg",
      lastModified: Date.now(),
    });

    setProfileImage(croppedImage);
  };
  const redirect = () => {
    history.push("/ExperienceUpdate");
  };
  const updateProfile = (e) => {
    e.preventDefault();
    
    const firstnameTrimmed = firstname ? firstname.toString().trim() : '';
    const lastnameTrimmed = lastname ? lastname.toString().trim() : '';
    
    if (!firstnameTrimmed || firstnameTrimmed.length === 0) {
      toast.error("First Name is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (firstnameTrimmed.length > 30) {
      toast.error("First Name must be 30 characters or less", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!lastnameTrimmed || lastnameTrimmed.length === 0) {
      toast.error("Last Name is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (lastnameTrimmed.length > 30) {
      toast.error("Last Name must be 30 characters or less", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!age || age.toString().trim() === "") {
      toast.error("Age is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!gender || gender.toString().trim() === "") {
      toast.error("Gender is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!nativeLocation || nativeLocation.toString().trim() === "") {
      toast.error("Native Location is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!currentLocation || currentLocation.toString().trim() === "") {
      toast.error("Current Location is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!qualification || qualification.toString().trim() === "") {
      toast.error("Education is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!tags || tags.length === 0) {
      toast.error("Skills are required. Please add at least one skill", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!about || about.toString().trim() === "") {
      toast.error("About Yourself is required", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    setLoading(true);

    const skillsString = tags.join(",");


    const FormData = require("form-data");

    const form = new FormData();

    form.append("first_name", firstnameTrimmed);
    form.append("last_name", lastnameTrimmed);
    form.append("qualification", qualification);
    form.append("age", age);
    form.append("gender", gender);
    form.append("native_location", nativeLocation);
    form.append("skills[]", skillsString);
    form.append("about_description", about);
    form.append("web_link", webLink);

    form.append("location", currentLocation);
    var file = new File([imageToCrop], "profile_image.jpg", {
      lastModified: new Date().getTime(),
      webkitRelativePath: "",
      type: "image/jpeg",
    });
    form.append("profile_image", imageToCrop);

    for (var pair of form.entries()) {

    }
    profileUpdateService
      .profileUpdatecall(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          history.goBack();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });

     
  };

  return (
    <section className="explore explore1">
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `
      }} />
      <LoadingOverlay>
        <div className="container">
          <div className="banner">
            <div className="row">
              <div className="col-md-4">
                <div className="breadcrumps">
                  <ul>
                    <li>
                      <a
                        href="#!"
                        onClick={(e) => {
                          back(e);
                        }}
                      >
                        <i className="bx bx-chevron-left" /> Back to Profile
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>
          <section className="onbord-section">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="title">{name}, tell us a bit more about yourself</h1>
              <p className="subtitle">GigFWS needs the below information to help you better.</p>
            </div>
          </div>
            <div className="row">
              <div className="col-md-12">
                <div className="board-box">
                  <form>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="profile-pic-wrapper">
                          <div
                            className="pic-holder"
                          >

                            <img
                              id="profilePic"
                              className="pic"
                              src={profileImage}
                            />

                           
                          </div>
                          <p className="text-info text-center small">
                            <button onClick={openCropProfilePicmodel}>Change Profile Photo</button>
                          </p>
                        </div>
                      </div>
                     
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="firstname"
                            className="form-control"
                            required="required"
                            placeholder="*First Name (Max. 30 characters)"
                            value={firstname}
                            onChange={(e) => {
                              filterNumeric(e.target.value, setFirstname);
                            }}
                            onKeyDown={preventNumeric}
                            maxLength="30"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="lastname"
                            className="form-control"
                            required="required"
                            placeholder="*Last Name (Max. 30 characters)"
                            value={lastname}
                            onChange={(e) => {
                              filterNumeric(e.target.value, setLastname);
                            }}
                            onKeyDown={preventNumeric}
                            maxLength="30"
                          />
                        </div>
                      </div>

                      
                      <div className="col-md-12">
                        <div className="form-group">
                          <label style={{ fontSize: '14px', marginBottom: '5px', color: '#333' }}>*Gender</label>
                          <select className="form-control" value={gender || ""} onChange={(e) => {
                              setGender(e.target.value);
                            }} required>
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="transgender">Transgender</option>
                            <option value="Wish not to answer">Wish not to answer</option>
                          </select>
                          
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="age"
                            className="form-control"
                            placeholder="*Age"
                            value={age}
                            onChange={(e) => {
                              setAge(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <LocationAutocomplete
                          value={nativeLocation}
                          onChange={setNativeLocation}
                          placeholder="*Native Location"
                          locationType="native"
                        />
                      </div>
                      <div className="col-md-12">
                        <LocationAutocomplete
                          value={currentLocation}
                          onChange={setCurrentLocation}
                          placeholder="*Current Location"
                          locationType="current"
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="weblink"
                            className="form-control"
                            placeholder="Weblink"
                            value={webLink}
                            onChange={(e) => {
                              setWebLink(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label style={{ fontSize: '14px', marginBottom: '5px', color: '#333' }}>*Education</label>
                          <Select
                            className="form-control"
                            options={[
                              {
                                label: "10th or Below 10th",
                                value: "10th or Below 10th",
                                selected: true,
                              },
                              { label: "12th Pass", value: "12th Pass" },
                              { label: "Diploma", value: "Diploma" },
                              { label: "Graduate", value: "Graduate" },
                              {
                                label: "Post Graduate",
                                value: "Post Graduate",
                              },
                              { label: "PhD", value: "PhD" },
                            ]}
                            placeholder={qualification}
                            onChange={(values) => {

                              setQualification(values[0].value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label style={{ fontSize: '14px', marginBottom: '5px', color: '#333' }}>*Add Skills</label>
                          <TagsInput
                            className={`form-control ${tags.length >= 10 ? 'tags-limit-reached' : ''}`}
                            value={tags}
                            placeholder="Add a Skill"
                            onChange={handletagChange}
                            inputProps={{
                              placeholder: tags.length >= 10 ? "" : "*skills",
                              disabled: tags.length >= 10,
                              maxLength: 30,
                            }}
                          />
                          <span>
                            {tags.length >= 10 
                              ? `Maximum 10 skills reached ` 
                              : `Please enter 'Tab' to add next skill`
                            }
                          </span>
                        </div>
                      </div>
                     
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="textarea">*About Yourself</label>
                          <textarea
                            name="about"
                            className="form-control"
                            placeholder="*Provide more details about yourself"
                            value={about}
                            maxLength="500"
                            onChange={(e) => {
                              setAbout(e.target.value);
                            }}
                            required
                          />
                          <div className="character-count">
                            {about ? about.length : 0} / 500
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 post-new-job">
                        <button onClick={updateProfile}>Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Modal
          isOpen={isProfilePicModelOpen}
          onRequestClose={closeProfilePicModel}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup profile-edit-seclect" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Profile Picture Select</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeProfilePicModel}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="terms-condition">
                  <div className="col-md-4">
                    <a href="#!">
                      <label
                        htmlFor="newProfilePhoto"
                        className="upload-file-block"
                      >
                        <input
                          className="uploadProfileInput"
                          type="file"
                          onChange={onImageChange}
                          name="profile_pic"
                          id="newProfilePhoto"
                          accept="image/*"
                          style={{ display: "none" }}
                        />
                        Select Picture
                        <img src="assets/images/attachement" />
                      </label>
                    </a>
                  </div>
                  <div>
                    <ImageCropper
                      imageToCrop={imageToCrop}
                      onImageCropped={(croppedImage) =>
                        setCroppedImage(croppedImage)
                      }
                    />
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </Modal>


        <Modal
          isOpen={isCropProfilePicModelOpen}
          onRequestClose={closeCropProfilePicModel}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup Profile-Picture-Select" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Profile Picture Select</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeCropProfilePicModel}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="terms-condition">
                  <CropProfileImage/>
                  
                </div>
              </div>
            </div>
          </div>
        </Modal>
        
        <Loader loading={loading} />
      </LoadingOverlay>
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEditView);